import React, { createContext, useEffect, useState } from 'react';
import { getAuth, signInWithPopup ,createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut,GoogleAuthProvider, updateProfile, sendEmailVerification, GithubAuthProvider } from "firebase/auth";
import app from '../firebase/firebase.config';


export const AuthContext = createContext();

const auth = getAuth(app);




const UserContext = ({children}) => {

    const [user,setUser] = useState(null);
    const [loading,setLoading] = useState(true);

    const googleProvider = new GoogleAuthProvider();
    
    const google = () =>{
        return signInWithPopup(auth, googleProvider)
    }

    const githubProvider = new GithubAuthProvider();
    const github = () => {
        return signInWithPopup(auth, githubProvider)
    }

    const createUser = (email,password) =>{
        setLoading(true);
        return createUserWithEmailAndPassword(auth,email,password);
    }
    const updateUserProfile = (profile) => {
        return updateProfile(auth.currentUser, profile);
    }
    const verifyEmail = () => {
        return sendEmailVerification(auth.currentUser);
    }
    const logIn = (email,password) =>{
        setLoading(true);
        return signInWithEmailAndPassword(auth, email, password);
    }
    const logOut =() =>{
        setLoading(true);
        return signOut(auth);
    }
// const user = {displayName: 'akash'};
    useEffect(() => {
            const unsubscribe = onAuthStateChanged (auth,currentUser => {
                    setUser(currentUser);
                setLoading(false);
            })
            return () =>{
                unsubscribe();
            }
    },[])

    const authInfo = {loading, 
        user , 
        createUser,
        updateUserProfile, 
        setLoading,
        logIn, 
        verifyEmail,
        logOut, 
        github,
        google};
    return (
        <div>
            <AuthContext.Provider value={authInfo}>
                {children}
            </AuthContext.Provider>
        </div>
    );
};

export default UserContext;